module.exports = __webpack_public_path__ + "img/find-online.848442ce.svg";